export default {
      id: "nav-savings-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#nav-savings",
      toString: function () {
        return this.url;
      }
    }